import React from 'react';
import { Calendar } from 'lucide-react';
import { parseMockDateToIso, formatToMockDate } from '@/shared/utils/dateUtils';

/**
 * Inline date range picker using two native date inputs, styled per project.
 * Controlled via `value = { from: 'YYYY-MM-DD'|''|null, to: 'YYYY-MM-DD'|''|null }`.
 */
export default function DateRangePicker({ value, onChange, className = '' }) {
  const fromMock = value?.from || '';
  const toMock = value?.to || '';
  const fromIso = parseMockDateToIso(fromMock) || '';
  const toIso = parseMockDateToIso(toMock) || '';

  const setFrom = (iso) => {
    const nextMock = iso ? formatToMockDate(new Date(`${iso}T00:00:00`)) : '';
    onChange?.({ from: nextMock, to: toMock });
  };
  const setTo = (iso) => {
    const nextMock = iso ? formatToMockDate(new Date(`${iso}T00:00:00`)) : '';
    onChange?.({ from: fromMock, to: nextMock });
  };

  return (
    <div className={`flex items-center gap-2 w-full sm:w-auto ${className}`}>
      <div className="relative inline-block flex-1 min-w-0 sm:w-auto sm:max-w-xs">
        <div className="pointer-events-none absolute left-3 top-2.5 text-gray-400">
          <Calendar className="h-4 w-4" />
        </div>
        <input
          type="date"
          value={fromIso}
          onChange={(e) => setFrom(e.target.value)}
          className="w-full pl-9 pr-3 py-2 text-sm rounded-md border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500"
        />
      </div>
      <span className="text-gray-400">-</span>
      <div className="relative inline-block flex-1 min-w-0 sm:w-auto sm:max-w-xs">
        <div className="pointer-events-none absolute left-3 top-2.5 text-gray-400">
          <Calendar className="h-4 w-4" />
        </div>
        <input
          type="date"
          value={toIso}
          onChange={(e) => setTo(e.target.value)}
          className="w-full pl-9 pr-3 py-2 text-sm rounded-md border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500"
        />
      </div>
    </div>
  );
}
